"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _index = _interopRequireDefault(require("./components/index"));
var registerComponent = function registerComponent(container, props) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_index.default, props), container);
};
exports.registerComponent = registerComponent;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-payment-calculator/dist/client/components/scss/index.scss');